import { Box, Button, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorPage = () => {
  const navigateToHome = useNavigate();
  const goToHome = () => {
    navigateToHome('/')
  }

  return (
    <Box
      display={"flex"}
      justifyContent="center"
      alignItems="center"
      mt="100px"
      flexDirection="column"
      px={4}
    >
      <Image
        src='https://i.ibb.co/h1Wpfr2/Green-and-Yellow-Retro-Blocks-Error-Page-Website-UI-Prototype.png'
        height={"400px"}
        width={"auto"}
        mb={4}
      />
      <Box textAlign={"center"}>
        <Text
          as="h1"
          fontSize={"36px"}
          fontWeight="bold"
          mb={2}
          color={"#6e17eb"}
        >
          Something Went Wrong !!
        </Text>
        <Text
          fontSize="18px"
          color="#6f7284"
          mb={3}
        >
          It looks like you've stumbled upon a page that doesn't exist. Don't worry, we've all been there!
        </Text>
        <Button
          onClick={goToHome}
          _hover={{ bgColor: '#000' }}
          bgColor="#5e17eb"
          w="209px"
          borderRadius="3px"
          color="white"
          fontSize="14px"
          m="10px"
        >
          GO TO HOME
        </Button>
      </Box>
    </Box>
  )
}

export default ErrorPage